import { useCallback, useEffect, useState } from 'react';
import { inventarioApi, isOfflineError, cache } from '../services/inventarioApi';
import { offlineQueue } from '../services/offlineQueue';
import { combinarFechaConHoraActual } from '../../../utils/horaLocal';
import {v4 as uuid} from 'uuid';

const ENTIDAD = 'traspasos-qr';

export function useTraspaso() {
  const [traspasosQR, setTraspasosQR] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchTraspasos = useCallback(async () => {
    try {
      const data = await inventarioApi.getAll(ENTIDAD);
      setTraspasosQR(data);
      cache.set(ENTIDAD, data);
    } catch (e) {
      if (isOfflineError(e)) setTraspasosQR(cache.get(ENTIDAD) || []);
      else console.error('Error fetch traspasos', e);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { fetchTraspasos(); }, [fetchTraspasos]);

  const traspasoQRCaja = async (monto, direccion, fechaRegistro = null) => {
    if (isNaN(monto) || monto <= 0) {
      alert('Monto inválido');
      return false;
    }
    const body = {
      id: uuid(),
      monto: parseFloat(monto),
      direccion,
      fecha: combinarFechaConHoraActual(fechaRegistro),
      anulado: false,
    };
    try {
      const created = await inventarioApi.create(ENTIDAD, body);
      setTraspasosQR(prev => {
        const updated = [...prev, created];
        cache.set(ENTIDAD, updated);
        return updated;
      });
      return true;
    } catch (e) {
      if (isOfflineError(e)) {
        const temp = { id: `temp_${Date.now()}`, ...body };
        setTraspasosQR(prev => {
          const updated = [...prev, temp];
          cache.set(ENTIDAD, updated);
          return updated;
        });
        offlineQueue.enqueue({ method: 'POST', entidad: ENTIDAD, body });
        return true;
      }
      return false;
    }
  };

  const anularTraspaso = async id => {
    if (!window.confirm('¿Anular este registro?')) return false;
    try { await inventarioApi.patch(ENTIDAD, { id, anulado: true }); await fetchTraspasos(); return true; }
    catch (e) {       alert(e.response?.data?.message || 'Conéctate para validar y guardar la corrección');
      return false; }
  };
  const editarTraspaso = async (id, monto) => {
    try { await inventarioApi.patch(ENTIDAD, { id, monto: Number(monto) }); await fetchTraspasos(); return true; }
    catch (e) {       alert(e.response?.data?.message || 'Conéctate para validar y guardar la corrección');
      return false; }
  };
  const editarFechaTraspaso = async (id, fecha) => {
    try { await inventarioApi.patch(ENTIDAD, { id, fecha }); await fetchTraspasos(); return true; }
    catch (e) {       alert(e.response?.data?.message || 'Conéctate para validar y guardar la corrección');
      return false; }
  };

  const obtenerTraspasos = () => traspasosQR.filter(t => !t.anulado);

  return {
    traspasosQR,
    traspasoQRCaja,
    anularTraspaso,
    editarTraspaso,
    editarFechaTraspaso,
    obtenerTraspasos,
    loading,
    refetch: fetchTraspasos,
  };
}